import React, { Component } from 'react';
import FaSpinner from 'react-icons/lib/fa/spinner';
import './styles.css';

class Loader extends Component {
  render(){
    if(!this.props.show) return null;
    return (
      <div className="loader-container">
        <FaSpinner className="icon-spin" size="50" color="#ef2734" />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js